interface LogoProps {
  className?: string
  size?: number
  showText?: boolean
}

export function Logo({ className = '', size = 32, showText = true }: LogoProps) {
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* Logo image - using logo.svg from public folder */}
      <img
        src="/logo.svg?v=1"
        alt="EcoSemantic Logo"
        style={{ width: size, height: size }}
        className="object-contain"
        onError={() => {}}
      />

      {showText && (
        <>
          <span className="text-xl font-bold">EcoSemantic</span>
          <span className="text-xs text-muted-foreground font-mono">MCP</span>
        </>
      )}
    </div>
  )
}
